import React from "react";
import { FutureStrategiesHeaderName } from "../../../components/tableHeaderNames/HeaderName";
import Table from "../../../components/table/Table";
import { useStrategiesContext } from "../../../context/derivatives/strategies/DerivativesStrategiesContext";
import DerivativesStrategiesForm from "./DerivativesStrategiesForm";

const DerivativesStrategiesTable = () => {
  const { filteredTableData, setSelectedRowDetails } = useStrategiesContext();

  const handleSelectedTableData = (row) => {
    setSelectedRowDetails({
      actions: row.actions,
      coordinates: row.coordinates,
      profit_factor: row.profit_factor,
      base_equity_last_price: row.base_equity_last_price,
    });
  };

  return (
    <Table
      tableData={filteredTableData}
      faCols={FutureStrategiesHeaderName}
      height="80vh"
      tableTitle={{
        title: "استراتژی‌ها",
        desc: "تست توضیحات",
      }}
      Form={DerivativesStrategiesForm}
      handleSelectedTableData={handleSelectedTableData}
      isRowSelection
      pointer
    />
  );
};

export default DerivativesStrategiesTable;
